import DashCard from "./DashCard";
import Locked from "../../../assets/locked-award.png";
import Crown from "../../../assets/crown-award.png";
import Trophy from "../../../assets/trophy-award.png";
import Hint from "../../../assets/hint-award.png";
import Medal from "../../../assets/medal-award.png";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
const AWARDBADGE = {
  "Persistence": Crown,
  "Ace Grade": Trophy,
  "Truth Seeker": Medal,
  "Grand Master": Crown,
  "No Hints": Hint,
};

const Award = ({ title, subtitle, unlocked }) => {
  const badgeImg = unlocked ? AWARDBADGE[title] || Crown : Locked;
  return (
    <div className="award">
      <img src={badgeImg} alt={`${title}-award`} />
      <div className={`${!unlocked ? "locked" : ""}`}>
        <b>{title}</b>
        <small>{subtitle}</small>
      </div>
    </div>
  );
};

const Accomplishments = ({ awards }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 670);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 670);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const awardElements = awards.map((award) => (
    <Award
      key={`award-${award.title}`}
      title={award.title}
      subtitle={award.subtitle}
      unlocked={award.unlocked}
    />
  ));

  return (
    <DashCard
      title="Accomplishments"
      cornerContent=""
      children={
        isMobile ? (
          /* Mobile: Swiper with forced single-row layout */
          <div className="mobile-carousel-wrapper">
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 2000, disableOnInteraction: false }}
              spaceBetween={10}
              slidesPerView={1}
              style={{ height: "100%" }}
              breakpoints={{
                670: { slidesPerView: 2 },
                495: { slidesPerView: 1 },
              }}
            >
              {awardElements.map((element, i) => (
                <SwiperSlide key={i}>{element}</SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          /* Desktop: Your original flex container */
          <div className="award-container">{awardElements}</div>
        )
      }
    />
  );
};

export default Accomplishments;
